module.exports = __webpack_public_path__ + "img/fuga.9806688a.svg";